// extracted by mini-css-extract-plugin
export default {"svg":"TBKvXY9d","spin":"mVPbUp_w"};